import React, { PureComponent } from "react";
import cx from "classnames";
//
import { ButtonBasic } from "./Button";

export default class CityButton extends PureComponent {
  onClick = () => {
    const { id, onClick } = this.props;

    onClick(id);
  };

  render() {
    const { name, disabled, active, help, ...rest } = this.props;

    let title = name;

    if (help) {
      title = (
        <span>
          {name}
          <small className="o-btn__help">({help})</small>
        </span>
      );
    }

    return (
      <ButtonBasic
        {...{
          title,
          full: true,
          disabled,
          className: cx({ active }),
          ...rest,
          onClick: this.onClick,
        }}
      />
    );
  }
}
